export var getOperations = function (state) { return state.operation.operations; };
export var getUploadedOperations = function (state) { return state.operation.uploadedOperations; };
export var getOperationsCountSelector = function (state) { return state.operation.operationsCount; };
//# sourceMappingURL=operation.js.map